import clsx from 'clsx'
import { Strapi4CTAByType } from '../../atoms-components/cta-by-type/cta-by-type'
import { FontSize, TStrapiV4SectionCardTwoWidget } from '../../common-types'
import { getColorHexFromDotBrandColorNotation } from '../../utils/colors'
import Title from '../../common-components/Title'
import StrapiV4Multimedia from '../../atoms-components/multimedia/multimedia'
import Carousel from '@/stories/components/Common/Carousel/Carousel'
import { eventData, eventMapping } from '../../strapi-v4.tracking'
import colors from '@ind-money/tailwind/tokens/colors'

type TProps = TStrapiV4SectionCardTwoWidget

export default function StrapiV4SectionCardTypeTwoWidget(props: TProps) {
  const {
    title,
    title_font_size = 'medium',
    sub_title,
    tag_text,
    cta_one,
    multimedia_cards,
    titleHtag,
    bg_color,
  } = props

  const tagTextColor = tag_text?.color?.color
    ? getColorHexFromDotBrandColorNotation(tag_text.color.color)
    : (tag_text?.color?.custom_color ?? '#ffffff')

  const hexColor = bg_color?.color
    ? getColorHexFromDotBrandColorNotation(bg_color.color)
    : null

  const bgColor = hexColor ?? bg_color?.custom_color ?? colors.brand.white

  const titleColor =
    bgColor === colors.brand.white ? colors.brand.black : colors.brand.white

  const subTitleColor =
    bgColor === colors.brand.white ? colors.brand.grey.dark : colors.brand.white

  const titleFontSizeClass =
    'text-center my-3 lg:my-5 font-medium  lg:font-semibold '

  let fontSize: FontSize = 'size-54'

  if (title_font_size === 'medium') {
    fontSize = 'size-54'
  }

  if (title_font_size === 'large') {
    fontSize = 'size-78'
  }

  return (
    <div>
      <section className={clsx('mx-auto flex flex-col items-center')}>
        {tag_text?.text && (
          <p
            className="w-fit rounded-sm px-4 py-1 text-center"
            style={{
              border: `0.5px solid ${tagTextColor}`,
              color: tagTextColor,
            }}
          >
            {tag_text.text}
          </p>
        )}

        <Title
          className={titleFontSizeClass}
          headingType={titleHtag}
          fontSize={fontSize}
          style={{
            color: titleColor,
          }}
        >
          {title}
        </Title>
        <p
          className="max-w-4xl text-center text-lg leading-7 text-brand-grey-dark lg:text-2xl lg:font-normal lg:leading-9"
          style={{
            color: subTitleColor,
          }}
        >
          {sub_title}
        </p>

        {cta_one && (
          <div className="my-6">
            <Strapi4CTAByType
              type={cta_one.type}
              url={cta_one.url}
              eventData={{
                ...eventMapping[eventData.strapiWidgetCtaClick],
                eventLabel: cta_one.text,
                section: title,
              }}
            >
              {cta_one.text}
            </Strapi4CTAByType>
          </div>
        )}

        {multimedia_cards && multimedia_cards.length > 0 && (
          <Carousel showDotsOnMobileOnly dots>
            <section className="mx-5 flex gap-4 lg:my-10 lg:gap-24 xl:mx-10">
              {multimedia_cards.map((el, idx) => {
                return (
                  <div
                    key={el.id ?? idx}
                    className="flex min-w-full flex-col items-center md:min-w-min md:px-4 xl:px-6"
                  >
                    {el.multimedia && (
                      <StrapiV4Multimedia data={el.multimedia} />
                    )}

                    <div className="mt-8 text-center">
                      {el.caption_text_one && (
                        <p className="text-sm font-medium text-brand-grey-base">
                          {el.caption_text_one}
                        </p>
                      )}
                      {el.caption_text_two && (
                        <p className="text-xl font-medium">
                          {el.caption_text_two}
                        </p>
                      )}
                    </div>
                  </div>
                )
              })}
            </section>
          </Carousel>
        )}
      </section>
    </div>
  )
}
